export const TKeyHomeMeidly = {
  HOME_MEIDLY_HERO_SUP_TITLE: "HOME_MEIDLY_HERO_SUP_TITLE",
  HOME_MEIDLY_HERO_TITLE_1: "HOME_MEIDLY_HERO_TITLE_1",
  HOME_MEIDLY_HERO_TITLE_2: "HOME_MEIDLY_HERO_TITLE_2",
  HOME_MEIDLY_HERO_TITLE_3_1: "HOME_MEIDLY_HERO_TITLE_3_1",
  HOME_MEIDLY_HERO_TITLE_3_2: "HOME_MEIDLY_HERO_TITLE_3_2",
  HOME_MEIDLY_HERO_TITLE_3_3: "HOME_MEIDLY_HERO_TITLE_3_3",
  HOME_MEIDLY_HERO_TITLE_3_4: "HOME_MEIDLY_HERO_TITLE_3_4",
  HOME_MEIDLY_HERO_TEXT_1: "HOME_MEIDLY_HERO_TEXT_1",
  HOME_MEIDLY_HERO_TEXT_2: "HOME_MEIDLY_HERO_TEXT_2",
  HOME_MEIDLY_HERO_SECONDARY_CTA: "HOME_MEIDLY_HERO_SECONDARY_CTA",
  HOME_MEIDLY_HERO_PRICING: "HOME_MEIDLY_HERO_PRICING",
  HOME_MEIDLY_DEMO_PLAY: "HOME_MEIDLY_DEMO_PLAY",
  HOME_MEIDLY_FLOW_TITLE_1: "HOME_MEIDLY_FLOW_TITLE_1",
  HOME_MEIDLY_FLOW_TITLE_2: "HOME_MEIDLY_FLOW_TITLE_2",
  HOME_MEIDLY_FLOW_IN_1: "HOME_MEIDLY_FLOW_IN_1",
  HOME_MEIDLY_FLOW_IN_2: "HOME_MEIDLY_FLOW_IN_2",
  HOME_MEIDLY_FLOW_IN_3: "HOME_MEIDLY_FLOW_IN_3",
  HOME_MEIDLY_FLOW_OUT_1: "HOME_MEIDLY_FLOW_OUT_1",
  HOME_MEIDLY_FLOW_OUT_2: "HOME_MEIDLY_FLOW_OUT_2",
  HOME_MEIDLY_FLOW_OUT_3: "HOME_MEIDLY_FLOW_OUT_3",
  HOME_MEIDLY_FLOW_OUT_4: "HOME_MEIDLY_FLOW_OUT_4",
  HOME_MEIDLY_FLOW_GOAL: "HOME_MEIDLY_FLOW_GOAL",
  HOME_MEIDLY_JOURNEY_1_TITLE: "HOME_MEIDLY_JOURNEY_1_TITLE",
  HOME_MEIDLY_JOURNEY_1_TEXT: "HOME_MEIDLY_JOURNEY_1_TEXT",
  HOME_MEIDLY_JOURNEY_2_TITLE: "HOME_MEIDLY_JOURNEY_2_TITLE",
  HOME_MEIDLY_JOURNEY_2_TEXT: "HOME_MEIDLY_JOURNEY_2_TEXT",
  HOME_MEIDLY_JOURNEY_3_TITLE: "HOME_MEIDLY_JOURNEY_3_TITLE",
  HOME_MEIDLY_JOURNEY_3_TEXT: "HOME_MEIDLY_JOURNEY_3_TEXT",
  HOME_MEIDLY_JOURNEY_4_TITLE: "HOME_MEIDLY_JOURNEY_4_TITLE",
  HOME_MEIDLY_JOURNEY_4_TEXT: "HOME_MEIDLY_JOURNEY_4_TEXT",
  HOME_MEIDLY_TOOLS_SUP_TITLE: "HOME_MEIDLY_TOOLS_SUP_TITLE",
  HOME_MEIDLY_TOOLS_TITLE: "HOME_MEIDLY_TOOLS_TITLE",
  HOME_MEIDLY_TOOLS_INTRO_TEXT: "HOME_MEIDLY_TOOLS_INTRO_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_1: "HOME_MEIDLY_TOOLS_CHECK_1",
  HOME_MEIDLY_TOOLS_CHECK_1_TEXT: "HOME_MEIDLY_TOOLS_CHECK_1_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_2: "HOME_MEIDLY_TOOLS_CHECK_2",
  HOME_MEIDLY_TOOLS_CHECK_2_TEXT: "HOME_MEIDLY_TOOLS_CHECK_2_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_3: "HOME_MEIDLY_TOOLS_CHECK_3",
  HOME_MEIDLY_TOOLS_CHECK_3_TEXT: "HOME_MEIDLY_TOOLS_CHECK_3_TEXT",
  HOME_MEIDLY_WHY_SUP_TITLE: "HOME_MEIDLY_WHY_SUP_TITLE",
  HOME_MEIDLY_WHY_TITLE: "HOME_MEIDLY_WHY_TITLE",
  HOME_MEIDLY_WHY_FRAGMENT_1: "HOME_MEIDLY_WHY_FRAGMENT_1",
  HOME_MEIDLY_WHY_FRAGMENT_2: "HOME_MEIDLY_WHY_FRAGMENT_2",
  HOME_MEIDLY_WHY_FRAGMENT_3: "HOME_MEIDLY_WHY_FRAGMENT_3",
  HOME_MEIDLY_WHY_FRAGMENT_4: "HOME_MEIDLY_WHY_FRAGMENT_4",
  HOME_MEIDLY_WHY_FRAGMENT_5: "HOME_MEIDLY_WHY_FRAGMENT_5",
  HOME_MEIDLY_WHY_FRAGMENT_6: "HOME_MEIDLY_WHY_FRAGMENT_6",
  HOME_MEIDLY_WHY_FRAGMENT_7: "HOME_MEIDLY_WHY_FRAGMENT_7",
  HOME_MEIDLY_WHY_FRAGMENT_8: "HOME_MEIDLY_WHY_FRAGMENT_8",
  HOME_MEIDLY_WHY_RESOLUTION_1: "HOME_MEIDLY_WHY_RESOLUTION_1",
  HOME_MEIDLY_WHY_RESOLUTION_2: "HOME_MEIDLY_WHY_RESOLUTION_2",
  HOME_MEIDLY_CTA_TITLE_1: "HOME_MEIDLY_CTA_TITLE_1",
  HOME_MEIDLY_CTA_TITLE_2: "HOME_MEIDLY_CTA_TITLE_2",
  HOME_MEIDLY_CTA_TITLE_3: "HOME_MEIDLY_CTA_TITLE_3",
  HOME_MEIDLY_CTA_STEP_1: "HOME_MEIDLY_CTA_STEP_1",
  HOME_MEIDLY_CTA_STEP_2: "HOME_MEIDLY_CTA_STEP_2",
  HOME_MEIDLY_CTA_STEP_3: "HOME_MEIDLY_CTA_STEP_3",
  HOME_MEIDLY_CTA_NO_CARD: "HOME_MEIDLY_CTA_NO_CARD",
  HOME_MEIDLY_CTA_BTN: "HOME_MEIDLY_CTA_BTN",
  HOME_MEIDLY_TOOLS_FLAGSHIP: "HOME_MEIDLY_TOOLS_FLAGSHIP",
  HOME_MEIDLY_TOOLS_UPCOMING: "HOME_MEIDLY_TOOLS_UPCOMING",
  HOME_MEIDLY_TOOLS_BTN_ACCESS: "HOME_MEIDLY_TOOLS_BTN_ACCESS",
  HOME_MEIDLY_TOOLS_BTN_NOTIFY: "HOME_MEIDLY_TOOLS_BTN_NOTIFY",
  HOME_MEIDLY_TOOLS_1_DESC: "HOME_MEIDLY_TOOLS_1_DESC",
  HOME_MEIDLY_TOOLS_2_DESC: "HOME_MEIDLY_TOOLS_2_DESC",
  HOME_MEIDLY_TOOLS_OFFERS_DESC: "HOME_MEIDLY_TOOLS_OFFERS_DESC",
  HOME_MEIDLY_TOOLS_3_DESC: "HOME_MEIDLY_TOOLS_3_DESC",
  HOME_MEIDLY_TOOLS_4_DESC: "HOME_MEIDLY_TOOLS_4_DESC",
  HOME_MEIDLY_TOOLS_5_DESC: "HOME_MEIDLY_TOOLS_5_DESC",
  HOME_MEIDLY_TOOLS_6_DESC: "HOME_MEIDLY_TOOLS_6_DESC",
  HOME_MEIDLY_TOOLS_7_DESC: "HOME_MEIDLY_TOOLS_7_DESC",
  HOME_MEIDLY_TOOLS_8_DESC: "HOME_MEIDLY_TOOLS_8_DESC",
  HOME_MEIDLY_PRICING_SUP_TITLE: "HOME_MEIDLY_PRICING_SUP_TITLE",
  HOME_MEIDLY_PRICING_TITLE: "HOME_MEIDLY_PRICING_TITLE",
  HOME_MEIDLY_PRICING_PERIOD_MONTHLY: "HOME_MEIDLY_PRICING_PERIOD_MONTHLY",
  HOME_MEIDLY_PRICING_PERIOD_ANNUAL: "HOME_MEIDLY_PRICING_PERIOD_ANNUAL",
  HOME_MEIDLY_PRICING_PERIOD_SAVE: "HOME_MEIDLY_PRICING_PERIOD_SAVE",
  HOME_MEIDLY_PRICING_PER_MONTH: "HOME_MEIDLY_PRICING_PER_MONTH",
  HOME_MEIDLY_PRICING_VAT: "HOME_MEIDLY_PRICING_VAT",
  HOME_MEIDLY_PRICING_BILLED_MONTHLY: "HOME_MEIDLY_PRICING_BILLED_MONTHLY",
  HOME_MEIDLY_PRICING_BILLED_ANNUALLY: "HOME_MEIDLY_PRICING_BILLED_ANNUALLY",
  HOME_MEIDLY_PRICING_INCLUDED: "HOME_MEIDLY_PRICING_INCLUDED",
  HOME_MEIDLY_PRICING_PRO_NAME: "HOME_MEIDLY_PRICING_PRO_NAME",
  HOME_MEIDLY_PRICING_PRO_TAGLINE: "HOME_MEIDLY_PRICING_PRO_TAGLINE",
  HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING: "HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING",
  HOME_MEIDLY_PRICING_PRO_FEATURE_CALLS: "HOME_MEIDLY_PRICING_PRO_FEATURE_CALLS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_PATTERNS: "HOME_MEIDLY_PRICING_PRO_FEATURE_PATTERNS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_AVATAR: "HOME_MEIDLY_PRICING_PRO_FEATURE_AVATAR",
  HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS: "HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_SCAN: "HOME_MEIDLY_PRICING_PRO_FEATURE_SCAN",
  HOME_MEIDLY_PRICING_PRO_FEATURE_SEQUENCES: "HOME_MEIDLY_PRICING_PRO_FEATURE_SEQUENCES",
  HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS: "HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT: "HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT",
  HOME_MEIDLY_PRICING_CUSTOM_NAME: "HOME_MEIDLY_PRICING_CUSTOM_NAME",
  HOME_MEIDLY_PRICING_CUSTOM_PRICE: "HOME_MEIDLY_PRICING_CUSTOM_PRICE",
  HOME_MEIDLY_PRICING_CUSTOM_BILLING: "HOME_MEIDLY_PRICING_CUSTOM_BILLING",
  HOME_MEIDLY_PRICING_CUSTOM_TAGLINE: "HOME_MEIDLY_PRICING_CUSTOM_TAGLINE",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_POOLED: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_POOLED",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SEATS: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SEATS",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_BRAND: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_BRAND",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_RIGHTS: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_RIGHTS",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_INTEGRATIONS:
    "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_INTEGRATIONS",
} as const;
